module.exports = __webpack_public_path__ + "img/logo-bayton-os-white.37e9f340.svg";